const styles = (theme) => ({
  button: {
    width: '100%',
    backgroundColor: theme.palette.background.main,
  },
});

export default styles;
